import { GET_STUDENT_PROFILE } from "./actionTypes";

// eslint-disable-next-line 
export default (state = {}, action) => {
    switch(action.type) {
       case GET_STUDENT_PROFILE:
          return action.payload;
       default:
          return state;  
    };
};